export const groupReportsColumns = [
  {
    title: "Group Name",
    dataIndex: "groupName",
    key: "groupName",
    fixed: "left", 
  },

  {
    title: "Total Employee",
    dataIndex: "totalEmployees",
    key: "totalEmployees",
  },
  {
    title: "Assigned Courses",
    dataIndex: "uniqueAssignedCourses",
    key: "uniqueAssignedCourses",
  },
  {
    title: "Unique Enrollments",
    dataIndex: "uniqueEnrollments",
    key: "uniqueEnrollments",
  },
  {
    title: "Completed Enrollments",
    dataIndex: "completedEnrollments",
    key: "completedEnrollments",
  },
  {
    title: "In Progress Enrollments",
    dataIndex: "inProgressEnrollments",
    key: "inProgressEnrollments",
  },
  {
    title: "Not Started Enrollments",
    dataIndex: "notStartedEnrollments",
    key: "notStartedEnrollments",
  },
  {
    title: "On Time Enrollments",
    dataIndex: "onTimeEnrollments",
    key: "onTimeEnrollments",
  },
  {
    title: "Late Enrollments",
    dataIndex: "lateEnrollments",
    key: "lateEnrollments",
  },
    {
    title: "On Track Enrollments",
    dataIndex: "onTrackEnrollments",
    key: "onTrackEnrollments",
  },
    {
    title: "Behind Schedule Enrollments",
    dataIndex: "behindScheduleEnrollments",
    key: "behindScheduleEnrollments",
  },
    {
    title: "Not due yet Enrollments",
    dataIndex: "notDueYetEnrollments",
    key: "notDueYetEnrollments",
  },

];
